import { createContext, useContext, useEffect, useState } from "react";
import { isTouch } from "@/lib/device";

// true on touch devices or when the OS asks for reduced motion. Resolved after mount so the
// first client render matches the prerendered HTML (no hydration mismatch).
export const FlatMotionContext = createContext(false);
export const useFlatMotion = () => useContext(FlatMotionContext);

export const prefersFlatMotion = () =>
  isTouch() || window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export function useFlatMotionState() {
  const [flat, setFlat] = useState(false);
  useEffect(() => {
    setFlat(prefersFlatMotion());
  }, []);
  return flat;
}

export const INSTANT = { duration: 0 };
